module.exports = __webpack_public_path__ + "static/media/youtube.5ea8c92c.jpg";